import React, { Fragment } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

// Components
import SocialMediaMention from "../../components/Card/SocialMediaMention";
import DigitalSentiment from "../../components/Chart/Sentiment";
import DigitalAverageCount from "../../components/Card/Average";

// Material Icons
import GoogleIcon from "@mui/icons-material/Google";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import BlurOnOutlinedIcon from "@mui/icons-material/BlurOnOutlined";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function GoogleSummary({ ...props }) {
  const { data, positiveSentiment, negativeSentiment, netralSentiment } = props;

  return (
    <Fragment>
      <Accordion
        sx={{
          borderRadius: "10px",
          boxShadow:
            "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
        }}
      >
        <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
          <Typography variant="body1" fontWeight="600">
            Platform: Google
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 4, pt: 1 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" fontWeight="600" sx={{ mb: 2 }}>
                Sentiment Analysis
              </Typography>
              <DigitalSentiment sentiment={data} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" fontWeight="600" sx={{ mb: 2 }}>
                Digital Mention
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <SocialMediaMention icon={<GoogleIcon />} data={data} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Typography variant="body2" fontWeight="600" sx={{ mb: 1 }}>
                    Sentiment Analysis
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <DigitalAverageCount
                    average={netralSentiment}
                    isAverage={true}
                    title="Total of Netral Sentiment"
                    icon={
                      <BlurOnOutlinedIcon
                        sx={{
                          width: 25,
                          height: 25,
                          color: "rgba(0, 0, 0, 0.6)",
                        }}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <DigitalAverageCount
                    average={negativeSentiment}
                    isAverage={true}
                    title="Total of Negatif Sentiment"
                    icon={
                      <ThumbDownOutlinedIcon
                        sx={{
                          width: 25,
                          height: 25,
                          color: "rgba(0, 0, 0, 0.6)",
                        }}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <DigitalAverageCount
                    average={positiveSentiment}
                    isAverage={true}
                    title="Total of Positive Sentiment"
                    icon={
                      <ThumbUpOutlinedIcon
                        sx={{
                          width: 25,
                          height: 25,
                          color: "rgba(0, 0, 0, 0.6)",
                        }}
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
}
